import type { GetStaticProps } from 'next'

import { WordPressApiClient } from '@/utils/WordPressApiClient'

export { ExposurePage as default } from '@/components/pages/News/Exposure'

export const getStaticProps: GetStaticProps = async () => {
  const wpClient = new WordPressApiClient()
  const mediaExposureList = await wpClient.fetchMediaExposureList()
  const mediaTypeList = [
    ...new Set(mediaExposureList.map(({ mediaType }) => mediaType.type)),
  ]

  return {
    props: {
      mediaExposureList,
      mediaTypeList,
    },
  }
}
